import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

export default function ProtectedRoute({ children, roles }) {
  const { user, loading, hasRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="flex items-center gap-3 text-slate-500">
          <div className="w-5 h-5 rounded-full border-2 border-blue-600 border-t-transparent animate-spin" />
          <span>Carregando...</span>
        </div>
      </div>
    );
  }
  if (!user) {
    // Extrair slug do path (garantia.algti.com/elo/dashboard -> slug: "elo")
    const pathParts = location.pathname.split('/').filter(p => p);
    const slug = pathParts.length > 0 && pathParts[0] !== 'login' ? pathParts[0] : null;
    
    // Redirecionar para /{slug}/login ou /login (Super Admin)
    const loginPath = slug ? `/${slug}/login` : '/login';
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }
  if (roles && roles.length > 0 && !hasRole(...roles)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
